<template>
  <div class="custom-form custom-form--forgot-password-2">
    <div class="custom-form__header">
      <slot name="content-introduction"/>
    </div>
    <form
      @submit.prevent="submit"
      novalidate autocomplete="off">
      <div class="fieldset">
        <field-input
          :live-validation="true"
          v-model="form.password"
          :v="$v.form.password"
          :field="fieldPassword"/>
      </div>
      <div class="fieldset">
        <field-input
          v-model="form.passwordConfirm"
          :v="$v.form.passwordConfirm"
          :field="fieldPasswordConfirm"/>
      </div>
      <div class="custom-form__actions">
        <div>
          <template v-if="!serverResponse && serverError === null">
            <button
              type="submit"
              :class="[ctaClass, { 'disabled': $v.form.$invalid }]"
              :disabled="$v.form.$invalid">
              <span class="btn__wrapper">{{ template.ctaSubmit }}</span>
            </button>
          </template>

          <template v-else>
            <a :href="ctaLink" :class="ctaClass">
              <span class="btn__wrapper">{{ template.ctaSuccess }}</span>
            </a>
          </template>
        </div>
        <div role="alert">
          <p v-if="serverResponse !== null"
             class="custom-form__response"
             :class="{ 'error': !serverResponse }">{{ serverResponse ? template.succeed : template.failure.default }}</p>
          <p v-if="serverError !== null"
             class="custom-form__response error">{{ template.error }}</p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { AnalyticsHandler,tag } from '@Foundation/analyticsHandler';
  import { helpers, minLength, required, sameAs } from 'vuelidate/lib/validators';
  import { validationMixin } from 'vuelidate';
  import FieldInput from '@Feature/CustomForms/fields/FieldInput/code/Scripts/components/field-input.vue';
  import { postData } from '@Foundation/services';

  /**
   * Custom validators vor Vuelidate
   */
  const atLeastOneNumber = helpers.regex('atLeastOneNumber', /(?=.*[0-9])/);
  const atLeastOneSymbol = helpers.regex('atLeastOneSymbol', /(?=.*\W)/); // at least one non-word character exists
  const atLeastOneUppercaseCharacter = helpers.regex('atLeastOneUppercaseCharacter', /(?=.*[A-Z-А-Я])/);

  export default {
    name: 'custom-form-forgot-password-2',

    components: { FieldInput },

    directives: { tag },

    mixins: [validationMixin],

    props: {
      fieldPassword: { type: Object, required: true, default: undefined },
      fieldPasswordConfirm: { type: Object, required: true, default: undefined },
      template: { type: Object, required: true, default: undefined },
      apiUrl: { type: String, required: true, default: undefined },
      userEmail: { type: String, required: true, default: undefined },
      ctaClass: { type: String, default: 'btn btn--primary' },
    },

    data() {
      return {
        form: {
          password: '',
          passwordConfirm: '',
        },
        ctaLink: null,
        serverResponse: null,
        serverError: null
      };
    },

    /**
     * Vuelidate config
     * @see {@link https://github.com/monterail/vuelidate|GitHub}
     */
    validations: {
      form: {
        password: {
          required,
          minLength: minLength(12),
          atLeastOneUppercaseCharacter, // Custom
          atLeastOneNumber, // Custom
          atLeastOneSymbol, // Custom
        },
        passwordConfirm: {
          required,
          sameAsPassword: sameAs('password'),
        },
      }
    },

    updated() {
      if (!this.$v.form.$invalid && document.getElementsByTagName('body')[0].classList.contains('is-using-keyboard')) {
        this.$el.querySelector('.btn__wrapper').focus();
      }
    },

    methods: {
      /**
       * @todo
       * @returns {undefined}
       */
      submit() {
        this.$v.form.$touch();
        if (this.$v.form.$pending || this.$v.form.$error) {
          return;
        } else {
          postData(`${window.location.origin}/${this.apiUrl}`, {
            'email': this.userEmail,
            'password': this.form.password
          })
            .then((response) => {
              if (typeof response === 'boolean') {
                this.serverResponse = response;
              } else {
                this.serverResponse = response.status;
                this.ctaLink = response.url;
                AnalyticsHandler.pushDataLayer({
                'event': 'uaevent',
                'ecommerce': 'undefined',
                'event_name': 'reset_password',
                'eventCategory': 'log in',
                'eventAction': 'select::reset password',
                'eventLabel': 'reset password'
                });
              }
            })
            .catch(() => {
              this.serverError = true;
            });
        }
      },
    }
  };
</script>

<style lang='scss' src="./custom-form-forgot-password-2.scss"></style>
